import { render, staticRenderFns } from "./notificacionesView.vue?vue&type=template&id=557f6f65&scoped=true"
import script from "./notificacionesView.vue?vue&type=script&lang=js"
export * from "./notificacionesView.vue?vue&type=script&lang=js"
import style0 from "./notificacionesView.vue?vue&type=style&index=0&id=557f6f65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f6f65",
  null
  
)

export default component.exports